import { render } from "./Home.vue?vue&type=template&id=7a1bb250&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=7a1bb250&lang=scss&scoped=true"

import exportComponent from "G:\\web2\\豪哥\\盘龙山陵园\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a1bb250"]])

export default __exports__